require('../../modules/es7.string.trim-left');
module.exports = require('../../modules/_core').String.trimLeft;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/polyfill/~/core-js/fn/string/trim-start.js
// module id = 418
// module chunks = 0